module.exports = __webpack_public_path__ + "c0bd01415f20677f887dfa56c934547b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/folder_add.png
// module id = 26
// module chunks = 0 1 2 3 4